<template>
  <v-color-picker
    class="brand-color-picker"
    :model-value="modelValue"
    mode="hex"
    :modes="['hex']"
    :elevation="0"
    hide-inputs
    v-bind="attrs"
    @update:model-value="onUpdate"
  />
</template>

<script setup>
import { useAttrs } from 'vue'

defineProps({
  // Hex color string (#rrggbb).
  modelValue: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue'])
const attrs = useAttrs()

// v-color-picker in hex mode emits an #rrggbbaa string; normalize to #rrggbb.
function onUpdate(value) {
  const hex = typeof value === 'string' ? value.slice(0, 7) : value
  emit('update:modelValue', hex)
}

defineOptions({ inheritAttrs: false })
</script>

<script>
export default { inheritAttrs: false }
</script>

<style lang="scss" scoped>
.brand-color-picker {
  border-radius: 12px;
}
</style>
